<h3 class="title-form">*RENTA IMPONIBLE Y DETERMINACIÓN DEL IMPUESTO</h3>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Renta bruta acumulada
		<br>
		<span style="font-size: 0.6em;"> al término de este trimestre, incluyendo rentas exentas, no afectas o que fueron sujetas a retención definitiva según artículo 52 "A" Ley del IVA</span>
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.goodsSales + form.servicesSales)" style="text-align:right;">
			{{form.goodsSales + form.servicesSales | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Rentas exentas
		<br>
		<span style="font-size: 0.6em;"> no afectas o que fueron sujetas a retención definitiva según artículo 52 "A" Ley del IVA, en este trimestre</span>
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.withholdings)" style="text-align:right;">
			{{form.withholdings | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Renta Neta:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.grossRent)" style="text-align:right;">
			{{form.grossRent | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Renta imponible estimada:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.estimatedTaxableIncome)" style="text-align:right;">
			{{form.estimatedTaxableIncome | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Impuesto determinado en este trimestre:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.taxDeterminedThisQuarter)" style="text-align:right;">
			{{form.taxDeterminedThisQuarter | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>